import { createContext } from 'react';
export const xrContext = createContext(undefined);
export const xrInputSourceStateContext = createContext(undefined);
export const xrSpaceContext = createContext(undefined);
export const combinedPointerContext = createContext(undefined);
